import React from "react";
import { useTranslation } from "react-i18next";
import { achivementCounter } from "../../constant/dummyData";

const Counter = () => {
  const { t } = useTranslation(); // Initialize translation

  return (
    <div
      className="section-padding bg-[url('../images/all-img/section-bg-15.png')]"
      style={{ marginTop: "20px", marginBottom: "20px" }}
    >
      <div className="container">
        {/* Section Title */}
        <div className="text-center">
          <div className="column-title">
            {t("achievements.title").split(" ")[0]}{" "}
            <span className="shape-bg">
              {t("achievements.title").split(" ")[1]}
            </span>{" "}
            {t("achievements.title").split(" ").slice(2).join(" ")}
          </div>
        </div>

        {/* Achievement Counters */}
        <div className="grid xl:grid-cols-4 md:grid-cols-2  grid-cols-1 gap-[30px] pt-10">
          {achivementCounter.map((item, index) => (
            <div
              key={index}
              className="bg-white shadow-box7 text-center pt-[64px] pb-8 px-[50px] rounded-[8px] relative my-4"
            >
              <img
                src={item.icon}
                alt=""
                className="absolute left-1/2 -translate-x-1/2 -top-10"
              />
              <h4 className="text-[44px] leading-[66px] text-black font-bold mb-1">
                <span className="counter">{item.num}</span>
              </h4>
              <p>{t(`achievements.${item.key}`)}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Counter;
